/**
 * FlagIcon - Renders a flag image from flagcdn.com instead of emoji
 * Windows doesn't support flag emoji, so we use SVG flags from CDN.
 * 
 * Usage: <FlagIcon code="pl" size={20} />
 */
import React from 'react';

const LANG_TO_COUNTRY = {
  pl: 'pl', en: 'gb', uk: 'ua', de: 'de', fr: 'fr',
  es: 'es', it: 'it', cs: 'cz', sk: 'sk', ru: 'ru',
};

export const getCountryCode = (code) => {
  if (!code) return 'xx';
  const lower = code.toLowerCase();
  return LANG_TO_COUNTRY[lower] || lower;
};

const FlagIcon = ({ code, size = 20, className = '' }) => {
  const country = getCountryCode(code);

  return (
    <img
      src={`https://flagcdn.com/${country}.svg`}
      alt={code?.toUpperCase() || ''}
      width={size}
      height={Math.round(size * 0.75)}
      className={className}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        borderRadius: 2,
        objectFit: 'cover',
      }}
    />
  );
};

export default FlagIcon;
